// Ocultar nombres de participantes: una sola función para todas las vistas (participantes, máquinas,
// ranking del torneo y vista pública del torneo), para que se vean siempre igual.
//
// Cada palabra del nombre y del apellido deja sus dos primeras letras y el resto se vuelve asteriscos:
//   JIMY PETTER RIEGA  ->  JI** PE**** RI***
export const maskName = (firstName, lastName1, hidden = true) => {
  const words = [firstName, lastName1]
    .flatMap((part) => String(part ?? '').trim().split(/\s+/))
    .filter(Boolean);
  if (!hidden) return words.join(' ');
  return words.map((word) => word.slice(0, 2) + '*'.repeat(Math.max(0, word.length - 2))).join(' ');
};
